import { login as loginApi, loginOut } from '@/api/login'
import { loginRAM } from '@/api/login'
import router from '@/router'
import { setTokenTime } from '@/utils/auth'
import { getMenuTableList } from '@/api/menu'
import SocketService from '@/utils/websocket'
import { handleTree, removeCookie } from '@/utils/index'
import { ElLoading } from 'element-plus'
import { compare } from '@/utils/index'

export default {
  namespaced: true,
  state: () => ({
    token: localStorage.getItem('token') || '',
    siderType: true,
    lang: localStorage.getItem('lang') || 'zh',
    region: '',
    company: '',
    companyList: [],
    timeData: {},
    getMenus: [], // 动态路由
    routerList: undefined,
    loading: {}, // 全局加载动画
    xmitechkey: 'dcbe9942ea563faf5d004a00b6e87767',
    registerRouteFresh: true // 控制路由请求菜单为true则获取路由 false则停止获取路由
  }),
  mutations: {
    setLoading(state) {
      state.loading = ElLoading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    setTimeData(state, timeData) {
      return new Promise((resolve, reject) => {
        state.timeData = timeData
        resolve()
      })
    },
    setCompanyList(state, companyList) {
      state.companyList = companyList
    },
    setCloseLoading(state) {
      state.loading.close()
    },
    setRegisterRouteFresh(state, registerRouteFresh) {
      state.registerRouteFresh = registerRouteFresh
    },
    setRouterList(state, routerList) {
      state.routerList = routerList
    },
    setToken(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    changeSiderType(state) {
      state.siderType = !state.siderType
    },
    changLang(state, lang) {
      state.lang = lang
    },
    setRegion(state, region) {
      state.region = region
    },
    setMenus(state, getMenus) {
      let menuList = []
      menuList = getMenus.sort(compare('orderNum'))
      menuList.forEach((item) => {
        if (item.children) {
          item.children = item.children.sort(compare('orderNum'))
        }
      })
      state.getMenus = menuList
    },
    setCompany(state, company) {
      state.company = company
    }
  },
  actions: {
    getMenuList({ commit }) {
      return new Promise((resolve, reject) => {
        getMenuTableList()
          .then((res) => {
            const menu = { menuId: 0, menuName: '主类目', children: [] }
            menu.children = handleTree(res.list, 'menuId')
            console.log(menu.children)
            commit('setMenus', menu.children)
            // 动态路由
            let arr = []
            menu.children.filter((itemRouter) => {
              // 是否存在子集
              let child = []
              if (itemRouter.children && itemRouter.children.length) {
                itemRouter.children.filter((val, i) => {
                  child.push({
                    name: val.path,
                    path: '/' + val.path,
                    component: () =>
                      require.ensure([], (require) =>
                        require(`@/views/${val.component}`)
                      ),
                    meta: {
                      title: val.menuName,
                      activeMenu: '/' + val.path,
                      noCache: val.noCache
                    }
                  })
                })
              }
              if (itemRouter.menuType === 'C') {
                let menuRouter = []
                menuRouter.push({
                  name: itemRouter.path,
                  path: '/' + itemRouter.path,
                  component: () =>
                    require.ensure([], (require) =>
                      require(`@/views/${itemRouter.component}`)
                    ),
                  meta: {
                    title: itemRouter.menuName,
                    activeMenu: '/' + itemRouter.path,
                    noCache: itemRouter.noCache
                  }
                })
                arr.push({
                  name: itemRouter.path + 's',
                  path: '/' + itemRouter.path + 's',
                  component: () => import('@/layout/index.vue'),
                  children: menuRouter
                })
              } else {
                arr.push({
                  name: itemRouter.path,
                  path: '/' + itemRouter.path,
                  component: () => import('@/layout/index.vue'),
                  meta: { title: itemRouter.menuName },
                  children: child
                })
              }
            })
            console.log(arr)
            commit('setRouterList', arr)
            resolve()
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    login({ commit, dispatch }, userInfo) {
      return new Promise((resolve, reject) => {
        if (userInfo.company_id !== undefined) {
          loginRAM(userInfo)
            .then((res) => {
              const token = res.xm_token
              let companyList = []
              companyList = res.company_list
              commit('setToken', token)
              localStorage.setItem('companyList', JSON.stringify(companyList))
              localStorage.setItem('company', companyList[0].companyId)
              localStorage.setItem(
                'region',
                companyList[0].region_list[0].region
              )
              setTokenTime()
              router.replace('/home')
              resolve()
            })
            .catch((err) => {
              reject(err)
            })
        } else {
          loginApi(userInfo)
            .then((res) => {
              const token = res.xm_token
              let companyList = []
              companyList = res.company_list
              commit('setToken', token)
              localStorage.setItem('companyList', JSON.stringify(companyList))
              localStorage.setItem('company', companyList[0].companyId)
              localStorage.setItem(
                'region',
                companyList[0].region_list[0].region
              )
              setTokenTime()
              router.replace('/home')
              resolve()
            })
            .catch((err) => {
              reject(err)
            })
        }
      })
    },
    // 退出
    logout({ commit }) {
      loginOut({})
        .then(() => {
          commit('setToken', null)
          commit('setRegisterRouteFresh', true)
          commit('setRegion', '')
          commit('setToken', '')
          localStorage.removeItem('region')
          localStorage.removeItem('company')
          localStorage.removeItem('user_id')
          localStorage.removeItem('password')
          localStorage.removeItem('token')
          removeCookie('xm-token')
          router.replace('/')
        })
        .catch((e) => {
          commit('setToken', null)
          commit('setRegisterRouteFresh', true)
          commit('setRegion', '')
          commit('setToken', '')
          localStorage.removeItem('region')
          localStorage.removeItem('company')
          localStorage.removeItem('user_id')
          localStorage.removeItem('password')
          localStorage.removeItem('token')
          removeCookie('xm-token')
          router.replace('/')
        })
    }
  }
}
